<app-header> </app-header>
@if (this.cookieConsent) {
  <div>
    <div class="cust-cookie-popup">
      <div class="d-md-flex align-items-md-start main-div">
        <p>Our website uses cookies to improve your experience and we assume you are OK with this. If not, you may opt out by visiting the privacy settings of  your browser to disable cookies.</p>
        <div class="accept-cta" (click)="acceptCookies();" >Accept</div>
      </div>
    </div>
  </div>
}
<router-outlet></router-outlet>
<app-footer></app-footer>